//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
  inject: ['reload'],
  props: {},
  data() {
    return {
      sys_info: {}
    }
  },
  created() {
    this.sys_info = this.data.sys_info
  },
  computed: {
    ...mapState(['data', 'userInfo']),
  },
  methods: {
    goBack() {
        location.reload()
    }
  }
}

